import { SearchUtils } from '@spotify/confidence-core-react';
import {
  TaskFragment,
  TaskFragmentDoc,
  TaskQuery,
  TaskQueryVariables,
  useOnTaskUpdatedSubscription,
  useTaskSuspenseQuery,
  withStandardGetSuspenseHook,
} from '@spotify/confidence-graphql';

const useTaskSuspenseImpl = withStandardGetSuspenseHook<
  TaskQuery,
  TaskFragment,
  'task',
  TaskQueryVariables
>(useTaskSuspenseQuery, 'task');

export const useTaskSuspense: typeof useTaskSuspenseImpl = options => {
  useOnTaskUpdatedSubscription({
    variables: {
      filter: `task.name:${SearchUtils.escapeQuery(options.name)}`,
    },
    onData: ({ client, data: result }) => {
      const task = result.data?.taskUpdated?.task;
      if (!task?.__typename || !task.name) return;
      client.cache.writeFragment({
        id: client.cache.identify(task),
        fragment: TaskFragmentDoc,
        fragmentName: 'Task',
        data: task,
      });
    },
  });

  return useTaskSuspenseImpl(options);
};
